export default __webpack_public_path__ + "static/media/DNo.24-6.33e64927.jpg";